import { Box } from "@mui/material"
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    Legend,
    PointElement,
    LineElement,
    Title,
    Filler,
    ScriptableContext,
} from "chart.js"
import { OreveButton } from "components/button/OreveButton.tsx"
import { useNavigate } from "react-router-dom"
import { useMmsService } from "services/mms/context/MmsServiceContext.tsx"
import React, { useEffect } from "react"
import { Loader } from "components/Loader.tsx"

ChartJS.register(
    CategoryScale,
    LinearScale,
    Legend,
    PointElement,
    LineElement,
    Title,
    Filler
);

interface DashboardGraphProps {
    startDate: string,
    endDate: string
}

export const DashboardGraph: React.FC<DashboardGraphProps> = ({startDate, endDate}) => {
    const navigate = useNavigate()
    const { metricsService } = useMmsService()
    const { useGetIntervalConsumption } = metricsService
    const { data, sendRequest } = useGetIntervalConsumption(startDate, endDate)

    useEffect(() => {
        sendRequest()
    }, [startDate, endDate])

    const dataGraph = () => {
        return {
            labels: data ? Object.keys(data) : [],
            datasets: [
                {
                    label: "Énergie (kWh)",
                    data: data ? Object.values(data) : [],
                    fill: "start",
                    backgroundColor: (context: ScriptableContext<"line">) => {
                        const ctx = context.chart.ctx;
                        const gradient = ctx.createLinearGradient(0, 0, 0, 700);
                        gradient.addColorStop(0, "rgba(57,198,16,1)");
                        gradient.addColorStop(0.7, "rgba(57,198,16,0)");
                        return gradient;
                    },
                    borderColor: "rgba(57,198,16,1)"
                },
            ]
        };
    };

    const legendMargin = {
        id: "legendMargin",
        beforeInit: function (chart) {
            const fitValue = chart.legend.fit;
            chart.legend.fit = function fit() {
                fitValue.bind(chart.legend)();
                return (this.height += 20);
            };
        }
    };

    const options = {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
            y: {
                min: 0,
                stepSize: 5,
            },
            x: {
                grid: {
                    display: false
                },
            }
        },
        elements: {
            line: {
                tension: 0.35
            },
        },
        plugins: {
            legend: {
                display: true,
                onClick: () => {
                },
                position: 'top' as const,
                align: 'start' as const,
                labels: {
                    usePointStyle: true,
                },
            },
        },
    };

    return (
        <Box sx={{display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '0.5rem', height: "100%", width: '100%'}}>
            <Box sx={{bgcolor: "grey.100", padding: "1rem", borderRadius: "15px", height: "93%", width: '100%' }}>
                { data ?
                    <Line data={dataGraph()} options={options} plugins={[legendMargin]} /> : <Loader />
                }
            </Box>
            <OreveButton value="Voir toutes mes recharges" onClick={() => navigate(`/sessions`)}/>
        </Box>
    )
}